import { fetchApi } from "@/utils/axios";
import URL from "@/api/urlConfig"

// 获取操作日志
export function getLogAggregate(data) {
  return fetchApi(URL.DATA_ANALYSIS_JOURNAL, data, "POST", "body");
}
